import React from 'react';
import ReactDOM from 'react-dom';
// import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import Routes from './Routes';
import configureStore from './store/ConfigureStore';
import 'react-toastify/dist/ReactToastify.css';

import 'Sagas/';

// const isProd = process.env.NODE_ENV === 'production';

const store = configureStore();


// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.Fragment>
//     <Provider store={store}>
//       <BrowserRouter >
//         <Routes />
//       </BrowserRouter>
//     </Provider>
//   </React.Fragment>
// );


// *** We need to keep the React 17 congif because, React 18 has the Automatic Batching across all update types (including async events) *** //

const renderRoot = () => {
  ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter history={history} context={{}}>
        <Routes />
      </BrowserRouter>
    </Provider>,
    document.getElementById('root')
  );
};

renderRoot();

// if (!isProd && module.hot) {
//   // Enable Webpack hot module replacement for reducers
//   module.hot.accept('./Routes', () => {
//     renderRoot();
//   });
// }


if('Notification' in window) {
  if(window.Notification.permission !== 'granted') {
    window.Notification.requestPermission().then(result => {
      console.log(result);
    })
  }
}

export {store}

